const Forms =
    [
        {
            type: 'multipleSelect',
            options: 'Entities',
            label: 'companies',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'CustomerName',
            id: 'CustomerName',
            id2: 'CustomerId',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'Status',
            label: 'status',
            id2: 'StatusId',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'Status',
            id: 'Status',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'CatTransportModes',
            label: 'transport_mode',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'TrasportMode',
            id2: 'TransportModeId',
            id: 'TrasportMode',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },{
            type: 'multipleSelect',
            options: 'CatServiceTypes',
            label: 'service_type',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'ServiceType',
            id2: 'TypesServiceId',
            id: 'ServiceType',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'multipleSelect',
            options: 'CatShipmentTypes',
            label: 'shipment_type',
            id2: 'ShipmentTypeId',
            class: 'col-md-3 col-lg-3 col-sm-12',
            name: 'ShipmentsType',
            id: 'ShipmentsType',
            datatype: 'select',
            show: true,
            style: { fontSize: '11px', fontWeight: 'bold' },
            value: "",
            values: []
        },
        {
            type: 'Datetime',
            label: 'create_date',
            name: 'SOCreationDate',
            class: 'col-md-3 col-lg-3 col-sm-12',
            id: 'SOCreationDate',
            id2: 'CreationDate',
            style : { fontSize : '11px',fontWeight:'bold'},
            value: "",
            format: "YYYY-MM-DD",
            values: []
        }
    ]

export default Forms